<template>
  <panel title="待办事项" class="mgb10">
    <div v-for="record of records" :key="record.label">
      <div v-if="record.number != 0" class="tasks-item">
        <router-link :to="record.path" v-if="record.number != 0">
          <div class="flex flex-between">
            <div class="blue">
              {{ record.label }}
            </div>
            <div v-if="record.number != null" class="red">
              {{ record.number }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </panel>
</template>
<script>
import Vue from "vue";
import Permit from "@/utils/permit";
import Util from "@/utils";
import ReturnBack from "@/api/returnBack.js";
import Rework from "@/api/rework.js";
import Reminder from "@/api/reminder.js";
import Bargain from "@/api/bargain.js";
import Event from "@/api/event.js";
import SynchronizeEdition from "@/api/synchronizeEdition.js";
import Inventory from "@/api/inventory.js";
import Damage from "@/api/damage.js";
import Hang from "@/api/hang.js";
//
import Order from "@/api/order.js";
import Purchase from "@/api/purchase.js";
import PurchaseChange from "@/api/purchaseChange.js";
import Delivery from "@/api/delivery.js";
import PickShelf from "@/api/pickShelf.js";
import PushShelf from "@/api/pushShelf.js";
import Allocate from "@/api/allocate.js";
import Receive from "@/api/receive.js";
import Quality from "@/api/quality.js";
import OrderMes from "@/api/orderMes.js";
import WorkOrder from "@/api/workOrder.js";
import ReceiveMms from "@/api/receiveMms.js";
import DeliveryRequisition from "@/api/deliveryRequisition.js";

export default {
  data() {
    return {
      Util: Util,
      items: [
        {
          label: "备货未完成",
          path: "/normal/oms/preparings",
          numberFun: Order.preparingCount,
          canEditions: ["af", "charge"],
          canExtendModels: ["oms"],
          canActions: ["orderDeal-available"],
        },
        {
          label: "客户返工待处理",
          path: "/normal/to-do-lists/customer-reworks",
          numberFun: Rework.customerReworkCount,
          canEditions: ["af", "charge"],
          canExtendModels: ["oms"],
          canActions: ["reworkCustomerView"],
        },
        {
          label: "客户催单",
          path: "/normal/to-do-lists/customer-reminders",
          numberFun: Reminder.receiverCount,
          canEditions: ["af", "charge"],
          canExtendModels: ["oms"],
          canActions: ["orderRemindered"],
        },
        {
          label: "财务审核拒绝",
          path: "/normal/oms/bargains?initFilter=financeVerifyReject",
          numberFun: Bargain.financeVerifyRejectCount,
          canEditions: ["charge"],
          canExtendModels: ["oms"],
          canActions: ["orderView"],
        },
        {
          label: "订单修改同步外采",
          path: "/normal/to-do-lists/synchronize-editions",
          numberFun: SynchronizeEdition.count,
          canEditions: ["bf", "charge"],
          canExtendModels: ["oms"],
          canActions: ["orderDeal-purchase"],
        },
        {
          label: "订单取消/退货后续处理",
          path: "/normal/to-do-lists/order-cancel-pending-deals",
          numberFun: Event.count,
          canEditions: ["bf", "charge"],
          canExtendModels: ["oms"],
          canActions: [
            "orderDeal-available",
            "orderDeal-manufacture",
            "orderDeal-purchase",
            "deliverAction",
          ],
        },
        {
          label: "我的返工",
          path: "/normal/to-do-lists/my-reworks",
          numberFun: Rework.unFinishCount,
          canEditions: ["bf", "charge"],
          canExtendModels: ["lmsO", "lmsE", "lmC", "wms"],
          canActions: ["receiveQuality", "wmsInventoryRework"],
        },
        {
          label: "退厂返工",
          path: "/normal/to-do-lists/return-factory-reworks",
          numberFun: Rework.countToFactory,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesReworkView"],
        },
        {
          label: "工序返工",
          path: "/normal/to-do-lists/phase-reworks",
          numberFun: Rework.phaseReworkCount,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesReworkView"],
        },
        {
          label: "挂单待处理",
          path: "/normal/to-do-lists/hangs",
          numberFun: Hang.unFinishCount,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesHangView"],
        },
        {
          label: "库存报警",
          path: "/normal/wms/inventories?initFilter=warnNo",
          numberFun: Inventory.warnCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsInventoryView"],
        },
        {
          label: "库存报损待审核",
          path: "/normal/wms/damages?initFilter=newly",
          numberFun: Damage.pendingAgreeCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsDamageVerify"],
        },
        //
        {
          label: "待确认",
          path: "/normal/oms/unconfirms",
          numberFun: Bargain.pendingConfrimCount,
          canEditions: ["charge"],
          canExtendModels: ["oms"],
          canActions: ["orderConfirm"],
        },
        {
          label: "待处理",
          path: "/normal/oms/pendings",
          numberFun: Order.pendingCount,
          canEditions: ["charge", "af"],
          canExtendModels: ["oms"],
          canActions: [
            "orderDeal-available",
            "orderDeal-manufacture",
            "orderDeal-purchase",
            "orderDeal-remake",
            "orderDeal-reject",
          ],
        },
        {
          label: "退货单",
          path: "/normal/to-do-lists/customer-returns",
          numberFun: ReturnBack.unFinishCount,
          canEditions: ["charge", "af"],
          canExtendModels: ["oms"],
          canActions: ["orderReturn"],
        },
        {
          label: "采购未下单",
          path: "/normal/pms/newlys",
          numberFun: Purchase.newlyCount,
          canEditions: ["charge", "bf"],
          canExtendModels: ["pms"],
          canActions: ["purchaseRetrivePlace"],
        },
        {
          label: "客户编辑价格待审核",
          path: "/normal/to-do-lists/purchase-changes",
          numberFun: PurchaseChange.unAcceptCount,
          canEditions: ["charge", "af"],
          canExtendModels: ["oms"],
          canActions: ["orderManage"],
        },
        {
          label: "我的催单",
          path: "/normal/pms/reminders",
          numberFun: Reminder.reminderCount,
          canEditions: ["charge"],
          canExtendModels: ["pms"],
          canActions: ["purchaseReminder"],
        },
        {
          label: "物料采购待质检",
          path: "/normal/mms/qas",
          numberFun: ReceiveMms.unQualityCount,
          canEditions: ["charge"],
          canExtendModels: ["mms"],
          canActions: ["mmsProcureQuality"],
        },
        {
          label: "物料采购待入库",
          path: "/normal/mms/putins",
          numberFun: ReceiveMms.unStorageCount,
          canEditions: ["charge"],
          canExtendModels: ["mms"],
          canActions: ["mmsInventoryInOutManage"],
        },
        {
          label: "待派单",
          path: "/normal/mes/pending-dispatchs",
          numberFun: OrderMes.pendingDispatchCount,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesOrderDispatch"],
        },
        {
          label: "生产工单",
          path: "/normal/mes/work-orders",
          numberFun: WorkOrder.inProductionCount,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesWorkOrderView"],
        },
        {
          label: "生产待尾查",
          path: "/normal/mes/qas",
          numberFun: WorkOrder.pendingQaCount,
          canEditions: ["charge"],
          canExtendModels: ["mes"],
          canActions: ["mesWorkOrderCheck"],
        },
        {
          label: "待入库",
          path: "/normal/wms/push-shelfs",
          numberFun: PushShelf.pendingPushCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsInventoryPushShelf"],
        },
        {
          label: "发货出库",
          path: "/normal/wms/pick-shelfs/delivery",
          numberFun: Delivery.pendingPickCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsInventoryPickShelf"],
        },
        {
          label: "调拨出库",
          path: "/normal/wms/pick-shelfs/allocate",
          numberFun: PickShelf.pendingPickAllocateCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsInventoryPickShelf"],
        },
        {
          label: "调拨待审核",
          path: "/normal/wms/allocates",
          numberFun: Allocate.pendingAgreeCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsAllocateView"],
        },
        {
          label: "报损待审核",
          path: "/normal/wms/damages",
          numberFun: Damage.pendingAgreeCount,
          canEditions: ["charge"],
          canExtendModels: ["wms"],
          canActions: ["wmsDamageView"],
        },
        {
          label: "待收货",
          path: "/normal/lms/pending-receives",
          numberFun: Receive.pendingReceiveCount,
          canEditions: ["charge", "bf"],
          canExtendModels: ["lmsC", "lmsE", "lmsO"],
          canActions: ["receiveView"],
        },
        {
          label: "待质检",
          path: "/normal/lms/pending-qas",
          numberFun: Quality.unQualityCount,
          canEditions: ["charge", "bf"],
          canExtendModels: ["lmsC", "lmsE", "lmsO"],
          canActions: ["receiveQuality"],
        },
        {
          label: "待发货",
          path: "/normal/lms/pending-delivers",
          numberFun: Bargain.deliveryCount,
          canEditions: ["charge", "af"],
          canExtendModels: ["lmsC", "lmsE", "lmsO"],
          canActions: ["deliverAction"],
        },
        {
          label: "发货申请单拒绝",
          path: "/normal/oms/delivery-requisitions?initFilter=reject",
          numberFun: DeliveryRequisition.rejectCount,
          canEditions: ["charge"],
          canExtendModels: ["oms"],
          canActions: ["deliveryRequisitionView"],
        },
      ],
      records: [],
    };
  },
  created() {
    const self = this;
    if (
      Permit.currentTenant() &&
      Permit.currentTenant().config.financeVerifyStrict == true
    ) {
      self.items.push({
        label: "订单待审核",
        path: "/fnReport/fn-reports/verifies/bargains",
        numberFun: Bargain.unFinanceVerifyCount,
        canEditions: ["charge"],
        canExtendModels: ["oms"],
        canActions: ["bargainFinanceVerify"],
      });
    }
    this.records = this.items.filter(
      (i) =>
        this.canEditionsFun(i) &&
        this.canExtendModelsFun(i) &&
        this.canActionsFun(i)
    );

    this.records.forEach((record) => {
      if (record.numberFun) {
        this.computeNumber(record);
      }
    });
  },
  methods: {
    showColor(number) {
      if (number == 0 || number == null || number == "") {
        return "";
      }
      return "red";
    },
    canEditionsFun(record) {
      if (record.canEditions && record.canEditions.length != 0) {
        return record.canEditions.includes(Permit.edition());
      }
      return true;
    },
    canExtendModelsFun(record) {
      for (const item of record.canExtendModels) {
        if (Permit.extendModels().includes(item)) {
          return true;
        }
      }
      return false;
    },
    canActionsFun(record) {
      for (const item of record.canActions) {
        if (Permit.canActions(item)) {
          return true;
        }
      }
      return false;
    },
    async computeNumber(item) {
      const self = this;
      if (item.numberFun) {
        let res = await item.numberFun();
        let number = res.data > 9999 ? "9999+" : res.data;
        Vue.set(item, "number", number);
      }
    },
  },
};
</script>

<style scoped>
ul.tasks {
  list-style: none;
}
ul.tasks,
ul.tasks li {
  margin: 0;
  padding: 0;
}
ul.tasks li {
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ed;
  line-height: 15px;
  height: 15px;
}
ul.tasks li:last-child {
  border: none;
}
ul.tasks li a {
  font-size: 13px;
  color: #696969;
}
ul.tasks li a.red div {
  color: red;
}

.tasks-item {
  padding: 10px 0;
  border-bottom: 1px solid #e4e7ed;
  line-height: 15px;
  height: 15px;
}
</style>